
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 14.075a6.2 6.2 0 100-12.4 6.2 6.2 0 000 12.4zm0 .8a7 7 0 100-14 7 7 0 000 14zm.525-6.25a.526.526 0 01-1.05 0l-.187-3.75a.713.713 0 111.425 0l-.188 3.75zM7 10.126a.75.75 0 110 1.5.75.75 0 010-1.5z","fill":"#D40605"}})])
      }
    
      }
    